import { useMemo } from 'react';

export const usePartnersCapital = (partners) => {
  const socialAmountTotal = useMemo(() => partners?.reduce((t, e) => {
    const goodsPartnerItem = e?.goods?.reduce((x, e) => {
      x += e?.monetaryValuation;
      return x;
    }, 0);
    t += goodsPartnerItem || 0;
    return t;
  }, 0), [partners]);
  
  const monetaryAmountTotal = useMemo(() => partners?.reduce((t, e) => {
    t += e?.contribution || 0;
    return t;
  }, 0), [partners]);
  
  const totalAmount = useMemo(() => socialAmountTotal + monetaryAmountTotal, [monetaryAmountTotal, socialAmountTotal]);
  
  return {
    socialAmountTotal,
    monetaryAmountTotal,
    totalAmount
  };
};
